import { render } from "./ClickWrapper.vue?vue&type=template&id=24203112&ts=true"
import script from "./ClickWrapper.vue?vue&type=script&lang=ts"
export * from "./ClickWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__